"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockEKEIgusGUIds = exports.mockExpieredEIQIgusGUIds = exports.mockEIQIgusGUIds = void 0;
const IgusGUId_1 = require("./IgusGUId");
exports.mockEIQIgusGUIds = [(0, IgusGUId_1.createIgusGUId)('IQU50-00015816')];
exports.mockExpieredEIQIgusGUIds = [(0, IgusGUId_1.createIgusGUId)('IQU50-00015816', { expired: true })];
exports.mockEKEIgusGUIds = [(0, IgusGUId_1.createIgusGUId)('COEKE0000427972')];
//# sourceMappingURL=mockIgusGUIds.js.map